import { authFetch } from './authFetch';

export interface ActivityLog {
  id: number;
  user: string;
  action: string;
  latitude: number | null;
  longitude: number | null;
  accuracy_meters: number | null;
  timestamp: string;
}

const API_URL = '/api/activity/';

export async function fetchActivityLogs(token: string): Promise<ActivityLog[]> {
  const res = await authFetch(API_URL, {}, token);
  if (!res.ok) throw new Error('Failed to fetch activity logs');
  return res.json();
}

export async function logLocation(
  token: string,
  payload: { latitude: number; longitude: number; accuracy_meters?: number; reason?: 'login' | 'periodic' }
): Promise<void> {
  const res = await authFetch(
    '/api/activity/location/',
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    },
    token
  );
  if (!res.ok) throw new Error('Failed to log location');
}
